import { render, staticRenderFns } from "./TaskTypeAcceptanceOfWork.vue?vue&type=template&id=b6a8ab02"
import script from "./TaskTypeAcceptanceOfWork.vue?vue&type=script&lang=js"
export * from "./TaskTypeAcceptanceOfWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports